import { ONE_ID_CLIENT_ID, ONE_ID_URL, WEB_URL } from '~constant/env';

export interface OneIdUrlParams {
  redirectUrl?: string;
  beforeUrl?: string;
  messageKey?: string;
}

/**
 * ONE ID페이지로 이동할 URL을 반환합니다.
 * @param param0
 * @returns
 */
export default function getOneIdUrl({
  redirectUrl = `${WEB_URL}/auth/login`,
  beforeUrl,
  messageKey = 'kreditjob_title',
}: OneIdUrlParams) {
  const BASE_URL = `${ONE_ID_URL}/login?service=kreditjob&client_id=${ONE_ID_CLIENT_ID}&message_key=${messageKey}`;
  const queryParams = [];

  if (redirectUrl) {
    queryParams.push(`redirect_url=${encodeURIComponent(redirectUrl)}`);
  }

  if (beforeUrl) {
    queryParams.push(`before_url=${encodeURIComponent(beforeUrl)}`);
  }

  return `${BASE_URL}${queryParams.length > 0 ? '&' : ''}${queryParams.join('&')}`;
}
